import HeadlessInput from '../../Headless';
import RedirectTile from '@/atoms/RedirectTile';
import { useModal } from 'context/Modal/Context';
import { MODAL_NAME } from 'context/Modal/MODAL_NAME';
import useAddressList from 'context/Modal/views/AddressList/hook';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { VARIANT_COLOR_ENUM } from '@/types/utils';
import { FormattedAddress } from 'utils/address';

type Props = {
  placeHolderLabel: string;
  name: string;
  modalTitle: string;
};

const AddressInput = ({ placeHolderLabel, name, modalTitle }: Props) => {
  const { openModal } = useModal();
  const { t } = useTranslation();
  const handleOpenAddressModal = async ({ onChange, title }: { onChange: (id: string) => void; title: string }) => {
    openModal(MODAL_NAME.ADDRESS_LIST, {
      onChange,
      title,
    });
  };
  const { addresses, isLoading } = useAddressList();
  const { watch } = useFormContext();
  const selectedId = watch(name);
  const selectedAddress = addresses?.length ? addresses.find((address) => address['@id'] === selectedId) : undefined;

  return (
    <HeadlessInput name={name}>
      {({ onChange }) => (
        <RedirectTile
          description={selectedAddress && selectedAddress.fullAddress && <FormattedAddress address={selectedAddress} />}
          error={selectedAddress && !selectedAddress.isEligible ? t('address.modal.notEligible') : undefined}
          icon={isLoading ? 'fa-solid fa-circle-notch animate-spin' : 'fa-regular fa-house'}
          label={selectedAddress?.fullAddress ? '' : placeHolderLabel}
          onClick={() => handleOpenAddressModal({ onChange, title: modalTitle })}
          tags={[
            ...(selectedAddress?.isDefaultBilling
              ? [{ label: t('isDefaultBilling'), color: VARIANT_COLOR_ENUM.NUBLU }]
              : []),
            ...(selectedAddress?.isDefaultShipping
              ? [{ label: t('isDefaultShipping'), color: VARIANT_COLOR_ENUM.NUBLU }]
              : []),
          ]}
        />
      )}
    </HeadlessInput>
  );
};

export default AddressInput;
